import { Typography, Box } from "@mui/material";

export default function SectionTitle({ title, subtitle }) {
  return (
    <Box textAlign="center">
      <Typography variant="h2">{title}</Typography>
      <Typography color="text.secondary" mt={1}>
        {subtitle}
      </Typography>
    </Box>
  );
}
